<template>
	<div id="piecewise">
		<div  id="piecewise" class="piecewise" :style="'margin-top:'+playHeight+'px'" ref="viewoutBox">
			<ul ref="innerBox" :style="'width:'+breakPoints.length*100+'px'" class="clearfix" :class="'piecewise'+styleType">
				<li v-for="(item,index) in breakPoints" :class="{active:(index == videoIndex),mini:(item.title.length > 6)}" :key="index">
					<a @click="switchVideo(item,index)" v-if="item.title.length > 6 && item.title.length <= 10">{{item.title.substr(0,5)}}<br/>{{item.title.substr(5)}}</a>
					<a @click="switchVideo(item,index)" v-else-if="item.title.length > 10">{{item.title.substr(0,7)}}<br/>{{item.title.substr(7)}}</a>
					<a @click="switchVideo(item,index)" v-else>{{item.title}}</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	props:['playHeight','breakPoint','styleType','videoIndex','dsId'],
	data(){
		return {
			loaded:false,
			disabled:false,
			page_nums:20,
			page:2,
			breakPoints:[]
		}
	},
	created() {
	
	},
	mounted() {
		 this.breakPoints = this.breakPoints.concat(this.breakPoint);
	},
	methods: {
		switchVideo(item,index){
			this.$emit('switchVideo',item,index);
		},
	}
}
</script>

<style scoped>
.piecewise {
	height: 40px;
	line-height: 30px;
	overflow-x: scroll;
	position: absolute;
	top: 56vw;
	left: 0;
	background: #fff;
	width: 100%;
	box-sizing: border-box;
	-webkit-overflow-scrolling: touch;
	overflow-scrolling: touch;
}

.piecewise ul {
	height: 40px;
	overflow: hidden;
}

.piecewise li {
	width: 92px;
	padding: 4px;
	float: left;
	height: 32px;
	overflow: hidden;
	position: relative;
}

.piecewise li:after {
	content: '';
	display: block;
	position: absolute;
	top: 8px;
	left: 0;
	width: 1px;
	height: 24px;
	background: #d4d4d4;
}

.piecewise li a {
	display: block;
	text-align: center;
	border-radius: 5px;
	height: 32px;
	overflow: hidden;
}

.piecewise li.active {
	background: #1483ff;
}

.piecewise2 li.active {
	background: #e5bc4b;
}

.piecewise3 li.active {
	background: #ec1a1a;
}

.piecewise li.active:after,
.piecewise li:first-child:after,
.piecewise li.active+li:after {
	display: none;
}

.piecewise li.active a {
	color: #fff;
}

.piecewise li.mini a {
	line-height: 16px;
	font-size: 11px;
}
</style>


// WEBPACK FOOTER //
// pieceWise.vue?069f9ac9